module.exports = __webpack_public_path__ + "static/media/travel-luggage.c9b04fe1.png";